<!-- @if (imageUrl && imageUrl != null && imageUrl != ' ') {
  <img [src]="imgPath" alt="avatar" class="media-img" [ngStyle]="styles()" />
} @else {
  <div class="no-media-image media-img" [ngStyle]="styles()">
    <span class="img-placeholder">{{ name | slice: 0 : 1 }}</span>
  </div>
} -->

@if (imagePath()) {
  <img
    [src]="imagePath()"
    alt="avatar"
    class="media-img"
    [style.width.px]="width()"
    [style.height.px]="height()"
  />
} @else {
  <div
    class="no-media-image media-img"
    [style.width.px]="width()"
    [style.height.px]="height()"
    [style.font-size.px]="fontSize()"
  >
    <span class="img-placeholder">
      {{ initialLetter() }}
    </span>
  </div>
}
